<template>
  <div class="flex w-fit max-w-48 items-center space-x-2">
    <div v-if="iconData" class="h-4 w-4">
      <icon-base
        v-tooltip="$t(iconData.tooltipKey)"
        :icon="iconData.icon"
        :icon-color="iconData.iconColor"
        :data-cy="iconData.dataCy"
        class="focus:outline-hidden"
      />
    </div>
    <component
      :is="templateRoute ? 'router-link' : 'span'"
      v-tooltip="model.name"
      class="line-clamp-2 text-headline"
      :data-cy="templateRoute ? 'template-name-link' : 'template-name-text'"
      v-bind="templateRoute ? { to: templateRoute } : {}"
      @click.stop
    >
      {{ model.name }}
    </component>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { EmailTemplateVisibility } from "@/enums/emailCustomization";
import { UTIL_COLORS } from "@/helpers/constants";
import {
  ROUTE_EMAIL_TEMPLATES_EDIT,
  ROUTE_SMS_TEMPLATES_EDIT,
} from "@/router/routes";

import IconGlobe from "@/components/icons/IconGlobe.vue";
import IconOrganization from "@/components/icons/sidebar/profile/IconOrganization.vue";

import type { CommunicationTemplate } from "@/models/clients";

const props = defineProps<{
  model: CommunicationTemplate;
  type?: "email" | "sms";
}>();

const routeNameMap = {
  email: ROUTE_EMAIL_TEMPLATES_EDIT,
  sms: ROUTE_SMS_TEMPLATES_EDIT,
};

const templateRoute = computed(() => {
  if (!props.model?.id || !props.type) {
    return null;
  }

  return {
    name: routeNameMap[props.type],
    params: {
      templateId: props.model.id,
    },
  };
});

const iconData = computed(() => {
  if (props.model.visibility === EmailTemplateVisibility.Global) {
    return {
      icon: IconGlobe,
      iconColor: UTIL_COLORS.PRIMARY,
      dataCy: "icon-globe",
      tooltipKey: "ORGANIZATION.COMMUNICATION_TEMPLATES.GLOBE_TOOLTIP",
    };
  }

  if (props.model.visibility === EmailTemplateVisibility.Organizational) {
    return {
      icon: IconOrganization,
      iconColor: UTIL_COLORS.PRIMARY,
      dataCy: "icon-organization",
      tooltipKey: "ORGANIZATION.COMMUNICATION_TEMPLATES.ORGANIZATION_TOOLTIP",
    };
  }

  return null;
});
</script>
